import { Form, required, Section, SectionSize, TextField } from '@eta/components';
import React, { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionButton, Checkbox } from '@fluentui/react';
import './VerifyCompleteProfileOTP.scss';
import PrivacyPolicy from './PrivacyPolicy';
import { MarkDownType } from '../../common/config/constants';

export interface FinalizeProfileProps {
    finalizeProfile:
    (
        Password: string,
        ConfirmPassword: string,
        FinalizeBtn: boolean
    ) => void;
}

const FinalizeCompleteProfile: FC<FinalizeProfileProps> = (
    props: FinalizeProfileProps
) => {

    const { finalizeProfile } = props;
    const { t } = useTranslation(['resources', 'VerifyOTP']);
    const [privacyType, setPrivacyType] = useState<string | undefined>();
    const [privacyPolicy, setPrivacyPolicy] = useState<boolean | undefined>(
        false
    );
    const [password, setPassword] = useState<string>();
    const [confirmPassword, setConfirmPassword] = useState<string>();
    const form = useRef(new Form({}));
    const [isFormValid, setIsFormValid] = useState<boolean>(
        form.current.isValid
    );
    form.current.onValidityChanged = (isValid) => setIsFormValid(isValid);

    const ClosePrivacy = () => {
        setPrivacyType(undefined);
    };

    useEffect(() => {
        if (isFormValid && privacyPolicy) {
            finalizeProfile(password ?? '', confirmPassword ?? '', true);
        } else {
            finalizeProfile('', '', false);
        }
    }, [isFormValid, privacyPolicy, password, confirmPassword]);

    return (
        <div className='verifyCompleteProfileOTP'>
            <div className="header">
                <h2>{t('VerifyOTP:finalize_ProfileHeader')}</h2>
            </div>
            <div className="bodyLine">
                <Section
                    size={SectionSize.h3}
                    title={t('VerifyOTP:account_Password')}
                />
            </div>
            <br />
            <div className='bodyLine'>
                <div>
                    <div className="bodyLine_finalize">
                        <TextField
                            type="password"
                            value={password}
                            label={t('form-components.Password')}
                            onChange={(_, v) =>
                                setPassword(v)
                            }
                            validationFunc={(v) =>
                                required(t, v, t('form-components.Password'))
                            }
                            onValidationChange={(isValid) =>
                                form.current.SetValidity('password', isValid)
                            }
                            required
                            toolTip={t('ToolTip.Password')}
                        />
                    </div>
                    <div className="bodyLine_finalize">
                        <TextField
                            type="password"
                            value={confirmPassword}
                            label={t('form-components.RetypePassword')}
                            onChange={(_, v) =>
                                setConfirmPassword(v)
                            }
                            validationFunc={(v) =>
                                required(
                                    t,
                                    v,
                                    t('form-components.RetypePassword')
                                )
                            }
                            onValidationChange={(isValid) =>
                                form.current.SetValidity(
                                    'confirmPassword',
                                    isValid
                                )
                            }
                            required
                        />
                    </div>
                </div>
                <div className='verticalSeperator' />
                <div className='content_verifyProfile'>
                    <div className='inner_div inner_finalize'>
                        <div className="privacy">
                            <div className="c-privacy">
                                <Checkbox
                                    checked={privacyPolicy}
                                    onChange={(_, checked) => {
                                        setPrivacyPolicy(checked);
                                    }
                                    }
                                />
                                <span className="PrivacyPolicy">
                                    <span className='dark'>{t('form.PrivacyPolicy')}</span>
                                    <ActionButton onClick={() => setPrivacyType(MarkDownType.Terms)}>{t('form.PrivacyPolicy2')}</ActionButton>
                                    <span className='dark'>{t('form.PrivacyPolicy3')}</span>
                                    <ActionButton onClick={() => setPrivacyType(MarkDownType.RegistrationPrivacy)}>{t('form.PrivacyPolicy4')}</ActionButton>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {privacyType && <PrivacyPolicy onClose={ClosePrivacy} hidden={!privacyType} type={privacyType} showCloseBtn/>}
        </div>
    );
};

export default FinalizeCompleteProfile;